import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/softs/batchrename/stepNumber-0.png")